/**
 * Demo Page
 * 
 * Main page for the interactive demo experience.
 */

import React from 'react';
import { DemoLayout } from '../components/Demo/DemoLayout';
import { DemoDataConnectionProvider, useDemoDataConnection } from '../contexts/DemoDataConnectionContext';
import './DemoPage.css';

const DemoPageContent: React.FC = () => {
  console.log('DemoPageContent: Component rendered');
  
  const {
    currentDemoUser,
    availableDemoUsers,
    setCurrentDemoUser
  } = useDemoDataConnection();

  console.log('DemoPageContent: Demo data connection state:', {
    currentDemoUser,
    availableDemoUsers: availableDemoUsers?.length,
    hasSetCurrentDemoUser: !!setCurrentDemoUser
  });

  const handleUserSelect = async (userId: string) => {
    console.log('DemoPageContent: handleUserSelect called with:', userId);
    const user = availableDemoUsers.find(u => u.id === userId);
    if (user) {
      await setCurrentDemoUser(user);
    }
  };

  return (
    <div className="demo-page">
      <DemoLayout
        currentDemoUser={currentDemoUser}
        availableDemoUsers={availableDemoUsers}
        onUserSelect={handleUserSelect}
      />
    </div>
  );
};

export const DemoPage: React.FC = () => {
  console.log('DemoPage: Component rendered');
  
  return (
    <DemoDataConnectionProvider>
      <DemoPageContent />
    </DemoDataConnectionProvider>
  );
};

export default DemoPage;
